import { render, staticRenderFns } from "./RecipientContractDetails.vue?vue&type=template&id=e030544e&scoped=true&"
import script from "./RecipientContractDetails.vue?vue&type=script&lang=js&"
export * from "./RecipientContractDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e030544e",
  null
  
)

export default component.exports